import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import 'react';
import PropTypes from 'prop-types';
import UserDataStepLayoutContainer$1 from '../../Layouts/UserDataStepLayoutContainer.js';
import { jsx } from '@emotion/react';
var _excluded = ["children"];
var UserDataStepLayoutContainer = function UserDataStepLayoutContainer(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return jsx(UserDataStepLayoutContainer$1, _extends({
    px: 4,
    mb: 4
  }, props), children);
};
UserDataStepLayoutContainer.propTypes = {
  children: PropTypes.node
};
UserDataStepLayoutContainer.defaultProps = {
  children: null
};
export { UserDataStepLayoutContainer as default };